export default __webpack_public_path__ + "static/media/Rakad_Dwairi_Cv.28fbdc9b.pdf";